module.exports = __webpack_public_path__ + "static/media/vid.fa841ba1.webm";